import PageHeader from "@/components/base/PageHeader";
import { useNavigate } from "react-router-dom";
import { achievements } from "@/mocks/profile";

export default function Achievements() {
  return (
    <div className="pb-[80px]">
      <PageHeader title="成就展示" subtitle="12/20 已解锁" backTo="/profile" />

      <div className="px-4 space-y-3">
        {achievements.map((a) => (
          <div
            key={a.id}
            className={`bg-white rounded-xl p-4 flex items-center gap-4 ${
              a.unlocked ? "" : "opacity-60"
            }`}
          >
            <div className={`w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0 ${
              a.unlocked ? "bg-accent-100" : "bg-background-100"
            }`}>
              <i className={`${a.icon} text-xl ${a.unlocked ? "text-accent-500" : "text-foreground-300"}`} />
            </div>
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-semibold ${a.unlocked ? "text-foreground-950" : "text-foreground-500"}`}>
                {a.name}
              </p>
              <p className="text-xs text-foreground-400 mt-0.5">{a.description}</p>
              {!a.unlocked && (
                <div className="mt-1.5 flex items-center gap-2">
                  <div className="flex-1 h-1.5 bg-background-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-primary-500 rounded-full"
                      style={{ width: `${a.progress}%` }}
                    />
                  </div>
                  <span className="text-[10px] text-foreground-400">{a.progress}%</span>
                </div>
              )}
            </div>
            {a.unlocked && (
              <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-green-500 text-sm" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}